import RectangleButton from '@/components/molecules/rectangleButton'
import Title from './title'
import Description from './description'

const Link = ({ link, titleRow1, titleRow2, description, buttonName }) => {
  return (
    <a
      href={link}
      target="_blank"
      className={`relative w-full cursor-pointer bg-beige hover:bg-dune transition-all duration-500 px-smallMobile md:px-mediumDesktop`}
    >
      <div className="relative w-full max-w-1440 mx-auto">
        <div
          className={`relative w-full flex flex-col lg:flex-row gap-x-mediumMobile xl:gap-x-[150px] py-largeMobile lg:py-mediumDesktop`}
        >
          <Title titleRow1={titleRow1} titleRow2={titleRow2} />
          <div className="flex flex-col w-full lg:max-w-[443px]">
            <Description description={description} />
            <RectangleButton
              name={buttonName}
              className="bg-background mt-smallMobile lg:mt-[28px]"
            />
          </div>
        </div>
      </div>
    </a>
  )
}

export default Link
